/* eslint-disable prettier/prettier */
import moment from "moment";

import qs from "qs";
import axios from "axios";
import {
    _
} from "core-js";

axios.defaults.withCredentials = true;

export class BookingForm {
    constructor(rideTypes, secondParam, store) {
        console.log("Constructing booking form");

        this.rideTypes = rideTypes;
        this.rideTypeCompatibilityChecked = false
        console.log(this.rideTypes);

        this.user = BookingForm.emptyUser();

        this.store = store;

        this.errors = this.emptyErrors();

        this.loading = false;

        this.bookingCostBreakdown = null;

        if (typeof secondParam === "string") {
            // TODO lookup number to try and find a user!

            // set booking to an empty booking!
            this.user = BookingForm.emptyUser();
            this.booking = BookingForm.emptyBooking();

            console.log(secondParam);

            if (secondParam != "") {
                console.log("Getting customer when constructing form");
                this.getCustomer(secondParam);
            }

            this.booking.ride_type = this.rideTypes[0].id;

            this.costs = [];
        } else {
            this.booking = secondParam.booking;
            this.user = secondParam.user;
            this.reviews = secondParam.reviews;

            // TODO get estimated costs
            this.costs = [];

            try {
                this.getCostEstimate();
            } catch (e) {
                console.log(e);
            }

        }
    }

    static showBusinessUser = false
    FIXED_COST_DISPATCHER() {
        return "fixed_cost_dispatcher";
    }

    FIXED_COST_AREA() {
        return "fixed_cost_area";
    }

    static emptyUser() {
        return {
            name: "",
            id: "",
            contact_number: "44",
            cards: [],
            promocodes: [],
            business: false,
            business_user: false,
            business_pickup_address: {},
            notes: "",
            recent_bookings: [],
            active_bookings: [],
            booked_bookings: [],
            locked_out: false,
            vip_customer: false,
        };
    }

    emptyErrors() {
        return {
            name: null,
            contact_number: null,
            pickup_time: null,
            additional_charge: null,
            final_cost: null,
            final_fare_driver: null,
            final_cost_driver: null,
            pickup_location: null,
            destinations: null,
            num_people: null,
            luggage: null,
            promocode: null,
            ride_type: null,
            payment_type: null,
            preassigned_driver: null,
            card: null,
            business_customer_name: null,
            business_customer_number: null,
            business_customer_reference: null,
            business_customer_authorized_by: null,
            business_customer_email: null,
            is_unconfirmed_update: null
        }
    }

    static emptyBooking() {

        var date = new Date();
        var newDate = new Date(date.getTime());

        var pickup_date = moment(newDate).format("YYYY-MM-DD");
        var pickup_time = moment(newDate).format("HH:mm");

        return {
            additionalChargeRequests: [],
            bestDriver: null,
            nearest5: null,
            asap: true,
            pickup_datetime: null,
            availabilityRegionName: "",
            pickup_time: pickup_time,
            pickup_date: pickup_date,
            business_customer_name: "",
            business_customer_number: "",
            business_customer_email: "",
            business_customer_reference: "",
            predefinedMessage: null,
            pickup_location: { invalid: false },
            pickup_info: BookingForm.emptyViaInfo(),
            destination_info: BookingForm.emptyViaInfo(),
            destinations: [{ invalid: false }],
            via_info: [],
            promocode: null,
            ride_type: null,
            taxi_type: null,
            num_people: BookingForm.DEFAULT_PAX(),
            luggage: null,
            needs_disabled_access: false,
            needs_pets: false,
            premium: false,
            flight_number: null,
            room_number: null,
            meet_and_greet: false,
            payment_type: BookingForm.DEFAULT_PAYMENT_TYPE(),
            card: null,
            payment_intent: null,
            cancellation_fee_payment_intent: null,
            additional_charge: 0,
            fixed_cost: false,
            final_cost: null,
            final_fare: null,
            final_fare_driver: null,
            driver_fare_commission: null,
            commission_from_driver: 0.20,
            fixed_cost_driver: false,
            final_cost_driver: null,
            booking_cancellation_fee: null,
            notes: "",
            priority: false,
            message: "",
            route: {
                time: null,
                distance_in_miles: null
            },
            eligibleDriversForPreassign: [],
            bookingAdditionalCharges: [],
            manual_dispatch: false,
            offer_booking_publically: false,
            fixedCostType: null,
            fixedCostDriverType: null,
            state: null,
            authorized_by: null,
            finalFareMode: false,
            zone: null,
            fixed_commission: null,
            availability_status: null,
            waiting_time_charges: null
        };
    }

    static emptyViaInfo() {
        return {
            active: false,
            name: "",
            contact_number: "",
            notes: ""
        };
    }

    static VEHICLE_TYPES() {
        return [{
            name: "Sal",
            type: "Saloon"
        },
        {
            name: "Est",
            type: "Estate"
        }, {
            name: "Mpv",
            type: "Mpv"
        }
        ];
    }

    static PAYMENT_TYPES() {
        return [{
            name: "Cash",
            type: "cash"
        },
        {
            name: "Card",
            type: "card"
        },
        {
            name: "Card in Cab",
            type: "card_in_cab"
        },
        {
            name: "Account",
            type: "account"
        }
        ];
    }

    paymentTypes() {
        return BookingForm.PAYMENT_TYPES();
    }

    static DEFAULT_PAX() {
        return 4;
    }

    static DEFAULT_PAYMENT_TYPE() {
        return "cash";
    }

    clearCards() { }

    clearPromocodes() { }

    async sendLocationToServer(loc) {

        console.log(JSON.stringify(loc));
        var res = await axios({
            url: `${this.store.state.apiUrl}/location/add`,
            method: "POST",
            params: {
                lat: loc.latLng.latitude,
                lon: loc.latLng.longitude,
                description: loc.description,
                custom: true,
            },
            headers: {
                "Content-Type": "application/json",
            },
        });

        loc.id = res.data.id;
        loc.invalid = false;
        loc.custom = true;

        console.log(res.data);
    }

    swapPickupAndDestination() {
        var tempDestination = this.booking.destinations[0];

        this.booking.destinations[0] = this.booking.pickup_location;
        this.booking.pickup_location = tempDestination;

        this.booking.destinations.reverse();

        var arrayData = this.booking.destinations;
        arrayData.unshift(arrayData.pop())

        this.getCostEstimate();

        try {
            this.getBestDriver();
        } catch (e) {
            console.log("Error getting best driver");
            console.log(e);
        }
    }

    addVia() {
        if (this.booking.destinations.length < 8) {
            this.booking.destinations.push({ invalid: false, via_info: BookingForm.emptyViaInfo() });
        }

        this.booking.via_info.push(BookingForm.emptyViaInfo());
    }

    updatePassengerCount() { }

    checkCanEstimateCosts(booking) {
        return true;
    }
    
    gotCostEstimate(response) {
        console.log("Got cost estimates");

        this.loading = false;

        this.costs = response.costs;
        this.booking.route.distance_in_miles = response.distance_in_miles;
        this.booking.route.time = response.time;
        this.booking.route.route_geometry = response.geometry;
        this.booking.zone = response.zone;
        this.booking.availabilityRegionName = response.availability_region;

        if (response.bookingAdditionalCharges != null) {
            this.booking.bookingAdditionalCharges.length = 0;
            this.booking.bookingAdditionalCharges.push(...response.bookingAdditionalCharges);
        }

        if (response.finalFareMode == true) {
            this.booking.finalFareMode = true;
        }

        this.updateFixedCosts();
        this.updateDriverCommission()
        this.findBestRide()

    }
    getBestDriver() {

        if (!this.booking) {
            return;
        }
        if (this.booking.state != null) {
            return;
        }

        this.booking.bestDriver = null;
        this.loadingBestDriver = true;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            return;
        }

        var errors = this.errors;

        // console.log("Getting best drivers for preassign");

        var vm = this;

        if (booking.pickup_time == "Invalid date") {
            booking.asap = true;
            booking.pickup_time = moment(new Date()).format("YYYY-MM-DD HH:mm");
        }

        var url = `${this.store.state.apiUrl}/overwatch/getBestDriverForBooking`;

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loadingBestDriver = false;

                if (res.data.error == "no_error" && res.data.driver != null) {
                    vm.booking.bestDriver = res.data.driver;
                    vm.booking.bestDriver.minutesFromPickup = res.data.minutes_from_pickup;
                    vm.booking.nearest5 = res.data.nearest_5;
                } else {
                    console.log(res.data.errors);
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loadingBestDriver = false;
                console.error(err);
            });
    }

    async getCostEstimate() {
        // console.log("Get cost estimate called");

        var canEstimateCosts = this.checkCanEstimateCosts(this.booking);

        this.booking.costs = [];
        this.loading = true;

        if (canEstimateCosts) {

            try {
                this.getBestDriver();
            } catch (e) {
                console.log(e);
            }

            try {

                if (this.booking.pickup_location.invalid == true) {
                    await this.sendLocationToServer(this.booking.pickup_location)
                }

                for (let i = 0; i < this.booking.destinations.length; i++) {
                    if (this.booking.destinations[i].invalid == true) {
                        await this.sendLocationToServer(this.booking.destinations[i]);
                    }
                }

            } catch (e) {
                console.log(e);
                alert("Error sending locations to server");
            }

            console.log('Getting estimated costs...');

            this.booking
            var url = `${this.store.state.apiUrl}/booking/getCostEstimate`;


            url += `?pickupLocation=${this.booking.pickup_location.id}`;

            if (this.booking.final_fare != null && this.booking.finaL_fare != 0) {
                url += `&forceEstimate=${(this.booking.final_fare * 100).toFixed(0)}`
            }

            if (this.booking.booking_type != null) {
                url += `&type=${this.booking.booking_type}`
            }

            for (let i = 0; i < this.booking.destinations.length; i++) {
                if (this.booking.destinations[i].id != null) {
                    url += `&destinationLocation=${this.booking.destinations[i].id}`;
                }
            }

            if (!this.booking.asap && this.booking.pickup_datetime != null && this.booking.pickup_datetime.isValid()) {
                url += `&pickupTime=${moment(this.booking.pickup_datetime).format("YYYY-MM-DD HH:mm")}`;
            }

            url += `&paymentType=${this.booking.payment_type}`;

            if (this.booking.promocode != null) {
                url += `&promocode=${this.booking.promocode}`;
            }

            url += `&phone=${this.user.contact_number}`;

            if (this.booking.additional_charge != null && !isNaN(this.booking.additional_charge)) {
                url += `&additionalCharge=${((this.booking.additional_charge == null ? 0 : this.booking.additional_charge) * 100).toFixed(0)}`;
            }

            var bacs = this.booking.bookingAdditionalCharges
            if (bacs != null) {

                for (var i = 0; i < bacs.length; i++) {
                    var bac = bacs[i];

                    if (bac.force == true) {
                        if (bac.locationAdditionalCharge != null) {
                            url += `&locationAdditionalChargesToForce=${bac.locationAdditionalCharge.id}`
                        } else if (bac.propertyAdditionalCharge != null) {
                            url += `&propertyAdditionalChargesToForce=${bac.propertyAdditionalCharge.id}`
                        }
                    }

                    if (bac.enabled == true) {
                        continue;
                    }

                    if (bac.locationAdditionalCharge != null) {
                        url += `&locationAdditionalChargesToIgnore=${bac.locationAdditionalCharge.id}`
                    } else if(bac.propertyAdditionalCharge != null) {
                        url += `&propertyAdditionalChargesToIgnore=${bac.propertyAdditionalCharge.id}`
                    }
                }
                
            }

            if (this.booking.needs_pets) {
                url+= `&pets=true`
            }

            if (this.booking.require_ppe) {
                url+= `&ppe=true`
            }

            if (this.booking.priority) {
                url += `&priority=true`
            }

            if (this.booking.meet_and_greet) {
                url += `&meetAndGreet=true`
            }

            if (this.booking.needs_disabled_access) {
                url += `&needsDisabledAccess=true`
            }


            // console.log(url);

            let completed = this.gotCostEstimate.bind(this);

            var vm = this;

            axios({
                url: url,
                method: 'GET',
                params: {},
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
                .then(function (res) {
                    completed(res.data);
                })
                .catch(function (err) {
                    vm.loading = false;
                    console.error(err);
                });
        } else {
            console.log('Cannot get estimated costs');
            this.loading = false;
        }

        this.findBestRide()
    }

    setEligibleDriversForPreassigned(drivers) {

        this.booking.eligibleDriversForPreassign.length = 0;

        for (var i = 0; i < drivers.length; i++) {
            drivers[i].idname =
                drivers[i].callsign + " " + drivers[i].name;
            this.booking.eligibleDriversForPreassign.push(drivers[i]);

        }

        console.log("Got " + drivers.length);
        console.log(drivers);
    }

    getEligibleDriversForPreassign() {
        var url = `${this.store.state.apiUrl}/overwatch/getEligibleDriversForPreassign`;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            return;
        }

        var errors = this.errors;

        console.log("Getting eligible drivers for preassign");

        var vm = this;

        if (booking.pickup_time == "Invalid date") {
            booking.asap = true;
            booking.pickup_time = moment(new Date()).format("YYYY-MM-DD HH:mm");
        }

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    vm.setEligibleDriversForPreassigned(res.data.drivers);
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    updateCostEstimate() { }

    saveAsQuote() { }

    addPromocode() { }

    addCard() { }

    removeCard() { }

    book() { }

    addReturn() { }

    update() { }

    changePaymentType(paymentType, card) {
        this.booking.payment_type = paymentType;

        if (paymentType == "card" && card == null) {
            // choose card in list!
            if (this.user.cards != null && this.user.cards.length > 0 && this.booking.card == null) {
                this.booking.card = this.user.cards[0].id;
            }
        } else {
            this.booking.card = card;
        }

        if (paymentType != "card") {
            console.log("Setting card and promocode to null");
            this.booking.promocode = null;
            this.booking.card = null;
        }

        this.getCostEstimate();
    }

    changePromocode(promocode) {
        if (this.booking.payment_type != 'acount') {
            this.booking.promocode = promocode;
            this.getCostEstimate();
        }
    }

    changeRideType(rideType) {
        this.booking.ride_type = rideType;

        var rideTypeObj = this.rideTypes.find(function (r) {
            return r.id == rideType;
        })

        this.booking.needs_disabled_access = rideTypeObj.disabledAccess;
        this.booking.premium = rideTypeObj.premiumVehicle;
        this.booking.num_people = rideTypeObj.numSeats;

        this.updateFixedCosts();

        try {
            this.getBestDriver();
        } catch (e) {
            console.log("Error getting best driver");
            console.log(e);
        }

        console.log("Changed ride type");
    }

    updateDriverCommission () {
        console.log('updating driver commission')
        var final_fare = this.booking.final_cost_driver
        console.log('final fare 0', final_fare)
        if (!final_fare) {
            console.log('final fare 1', final_fare)
            final_fare = this.booking.final_fare
        }
        if(!final_fare) {
            console.log('final fare 2', final_fare)
            final_fare = (this.getCost()/100 ).toFixed(2);
        }
        console.log('final fare 3', final_fare)
        if (this.booking.driver_percentage) {
            this.booking.driver_fare_commission = (this.booking.driver_percentage/100) * final_fare
        } else {
            this.booking.driver_fare_commission = this.booking.commission_from_driver * final_fare
        }
        // this.booking.fixed_commission = this.booking.commission_from_driver * final_fare
        console.log('final fare 4', this.booking.driver_fare_commission)
    }

    getCost() {
        if (this.costs != null) {

            let booking = this.booking
            var costForRideType = this.costs.find(function (cost) {
                return cost.id == booking.ride_type;
            });
            if (costForRideType != null) {
                return costForRideType.estimate;
            } else {
                return null;
            }
        }
    }


    updateFixedCosts() {
        try {

            var booking = this.booking;

            var estimatedCost = this.costs.find(function (cost) {
                return cost.id == booking.ride_type;
            });

            if (estimatedCost == null) {
                return;
            }


            this.bookingCostBreakdown = estimatedCost.booking_cost_breakdown;


            if (estimatedCost.fixed_cost != null) {

                if (this.booking.fixedCostType == null || this.booking.fixedCostType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost = true;

                    if (estimatedCost.booking_cost_breakdown != null && estimatedCost.booking_cost_breakdown.cost_without_extras != null) {
                        this.booking.fixed_cost_without_extras = estimatedCost.booking_cost_breakdown.cost_without_extras;
                        this.booking.final_fare = (estimatedCost.booking_cost_breakdown.cost_without_extras / 100);
                    } else {
                        this.booking.final_fare = (estimatedCost.estimate / 100);
                    }
                    this.booking.fixedCostType = this.FIXED_COST_AREA();
                }

                if ((this.booking.fixedCostDriverType == null && estimatedCost.final_cost_driver != null) || (this.booking.fixedCostDriverType == this.FIXED_COST_AREA() && estimatedCost.final_cost_driver != null)) {
                    this.booking.fixed_cost_driver = true;
                    this.booking.final_cost_driver = (estimatedCost.final_cost_driver / 100);
                    this.booking.fixedCostDriverType = this.FIXED_COST_AREA();
                    console.log("Setting fixed cost driver to true");
                    console.log(estimatedCost.final_cost_driver);
                }
            } else if (booking.state == null || (booking.state != 'cancelled' && booking.state != 'completed')) {
                if (this.booking.fixedCostType == null || this.booking.fixedCostType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost = false;
                    this.booking.final_fare = null;
                    this.booking.fixedCostType = null;
                }

                if (this.booking.fixedCostDriverType == null || this.booking.fixedCostDriverType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost_driver = false;
                    this.booking.final_cost_driver = null;
                    this.booking.fixedCostDriverType = null;
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    toggleAsap() {
        this.booking.asap = !this.booking.asap;

        if (!this.booking.asap) {
            this.setPickupTimeAhead(15);
            return;
        }

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }

    updateDate() {

        console.log("Date updated");

        this.booking.asap = false;

        var date = moment.utc(
            this.booking.pickup_date + " " + this.booking.pickup_time,
            "YYYY-MM-DD HH:mm", true
        );

        console.log(date);

        this.booking.pickup_datetime = date;

        console.log("Updated date " + date.toISOString());

        if (date == null) {
            return;
        }

        // if (date.isBefore(moment(new Date(date.getTime() + 15 * 60000)))) {
        //     return;
        // }

        console.log("getting cost estimate for date");

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }

    setPickupTimeAhead(minutes) {

        console.log("Set pickup time ahead");

        this.booking.asap = false;

        var date = new Date();
        var newDate = new Date(date.getTime() + minutes * 60000);

        this.booking.pickup_datetime = moment(newDate);

        // this.booking.pickup_date = moment(newDate).format("YYYY-MM-DD");
        this.booking.pickup_time = moment(newDate).format("HH:mm");

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }



    clear() {
        this.booking = BookingForm.emptyBooking();

        this.booking.ride_type = this.rideTypes[0].id;
        this.costs = [];
    }

    async getCustomer(contactNumber) {
        this.clearCustomer();

        try {
            var url = `${this.store.state.apiUrl
                }/customer/getCustomerDetailsForMakeBooking?contact_number=${encodeURIComponent(contactNumber)}`;

            let response = await axios.get(url, {
                params: {}
            });

            console.log("Getting customer " + contactNumber);

            if (response.data.error == null || response.data.error == "no_error") {
                this.user.cards = response.data.cards;
                this.user.promocodes = response.data.promocodes;
                this.user.business = response.data.business;
                this.user.business_pickup_address =
                response.data.business_pickup_address;
                this.user.notes = response.data.notes;
                if (response.data.driver_notes) {
                this.user.driver_notes = response.data.driver_notes;
                this.booking.message = response.data.driver_notes;
                } else {
                    this.user.driver_notes = '';
                    this.booking.message = '';
                }
                this.user.recent_bookings = response.data.recent_bookings;
                this.user.active_bookings = response.data.active_bookings;
                this.user.booked_bookings = response.data.booked_bookings;
                this.user.locked_out = response.data.locked_out;

                this.user.name = response.data.name;
                this.user.contact_number = response.data.contact_number;
                this.user.vip_customer = response.data.vip_customer;
                this.user.id = response.data.id;
                this.errors.name = null;
                this.errors.contact_number = null;

                this.user.business_payment_type = response.data.business_payment_type;

                if (this.booking.id == null && this.user.business_pickup_address != null && this.booking.pickup_location.id == null) {
                    console.log("Setting pickup location from business");
                    this.booking.pickup_location.id = this.user.business_pickup_address.location.id;
                    this.booking.pickup_location.description = this.user.business_pickup_address.location.description;
                    this.booking.pickup_location.latLng = {
                        latitude: this.user.business_pickup_address.location.lat,
                        longitude: this.user.business_pickup_address.location.lon,
                    }
                }

                if (this.booking.id == null && this.user.business_payment_type != null) {
                    this.booking.payment_type = this.user.business_payment_type;

                    if (this.booking.payment_type == 'card' && this.user.cards != null && this.user.cards.length > 0) {
                        this.booking.card = this.user.cards[0].id;
                    }

                }

                if (this.booking.id == null && response.data.priority != null) {
                    this.booking.priority = response.data.priority;
                }


                this.getCostEstimate();
            } else {
                console.log("Customer not found")
                this.user.contact_number = contactNumber;
            }

        } catch (error) {
            this.loading = false;
            console.log("Failed to get customer " + error);
        }

    }

    clearCustomer() {
        console.log("Clearing customer");

        this.user.cards = [];
        this.user.id = ''
        this.user.promocodes = [];
        this.user.business = false;
        this.user.business_pickup_address = {};
        this.user.notes = "";
        this.user.driver_notes = "";
        this.user.recent_bookings = [];
        this.user.active_bookings = [];
        this.user.locked_out = false;

        this.booking.promocode = null;
        this.booking.card = null;

        // this.booking.payment_type = BookingForm.DEFAULT_PAYMENT_TYPE();

    }

    findBestRide() {
        if (!this.costs) {
            return;
        }
        if (!this.booking.luggage || !this.booking.num_people) {
            return;
        }

        this.costs.sort(function(a, b) {
            return a.priority - b.priority;
        });

        let bestRideSelected = null
        for (let i = 0; i < this.costs.length; i++) {
            let bestRide = this.costs[i].rideTypeCapacity.find(rideType => {
                return rideType.max_luggage >= this.booking.luggage && rideType.num_seats >= this.booking.num_people && (this.booking.taxi_type == null || this.booking.taxi_type.toLowerCase == rideType.body_type.toLowerCase)
            })
            if (bestRide) {
                bestRideSelected = this.costs[i]
                break
            }
        }
        if (bestRideSelected && !this.booking.state) {
            this.booking.ride_type = bestRideSelected.id
        }
    }
    isSelectedRideTypeCompatible() {

        if (!this.costs) {
            return;
        }

        let selectedCost = this.costs.find(cost => {
            return cost.id == this.booking.ride_type
        })

        if (selectedCost.rideTypeCapacity == null || !selectedCost.rideTypeCapacity.length) {
            return true
        }

        let bestRide = selectedCost.rideTypeCapacity.find(rideType => {
            return rideType.max_luggage >= this.booking.luggage && rideType.num_seats >= this.booking.num_people && (this.booking.taxi_type == null || this.booking.taxi_type.toLowerCase == rideType.body_type.toLowerCase)
        })
        

        if (bestRide) {
            return true
        }
        return false
    }

    clearCustomerId() {
        this.user.id = ''
    }
    checkPromocodeStillActive() {
        if (this.booking.promocode == null) {
            return;
        }

        var booking = this.booking;
        var promocode = this.user.promocodes.find(function (p) {
            return p.id == booking.promocode;
        });

        if (promocode == null) {
            return;
        }

        if (!this.promocodeWillBeActive(promocode)) {
            console.log("Clearing promocode as it would no longer be active");
            this.booking.promocode = null;
        }
    }

    promocodeWillBeActive(p) {
        var pickupTime;

        var booking = this.booking;

        if (booking.asap) {
            pickupTime = new Date();
        } else {
            pickupTime = booking.pickup_datetime;
        }

        var pickupTimeMoment = moment(pickupTime);

        var promocodeExpiry = moment(p.expiry_date, "DD/MM/YYYY HH:mm");
        var promotionExpiry = moment(
            p.promocode.promotion.end_date,
            "DD/MM/YYYY HH:mm"
        );

        return (
            pickupTimeMoment.isBefore(promocodeExpiry) &&
            pickupTimeMoment.isBefore(promotionExpiry)
        );
    }

    rebook(b) {

        console.log(this.booking);

        var asap = this.booking.asap;

        var pickup_date = this.booking.pickup_date;
        var pickup_time = this.booking.pickup_time;

        var out = BookingForm.jsonToBookingFormBookingUser({
            booking: b
        });

        this.booking = out.booking;
        this.booking.state = null;
        this.booking.additional_charge = 0;

        this.booking.asap = asap;

        this.booking.pickup_date = pickup_date;
        this.booking.pickup_time = pickup_time;

        if (!this.booking.asap) {
            this.updateDate();
        }

        if (this.booking.ride_type == null || this.booking.ride_type == undefined) {
            this.booking.ride_type = this.rideTypes[0].id;
        }

        if (this.booking.fixed_cost != true) {
            this.booking.fixed_cost = false;
            this.booking.final_cost = null;
        }

        this.getCostEstimate();

    }
    returnBook(b) {

        console.log(this.booking);

        var asap = this.booking.asap;

        var pickup_date = this.booking.pickup_date;
        var pickup_time = this.booking.pickup_time;

        var out = BookingForm.jsonToBookingFormBookingUserForReturnBooking({
            booking: b
        });

        this.booking = out.booking;
        this.booking.state = null;
        this.booking.additional_charge = 0;

        this.booking.asap = asap;

        this.booking.pickup_date = pickup_date;
        this.booking.pickup_time = pickup_time;

        if (!this.booking.asap) {
            this.updateDate();
        }

        if (this.booking.ride_type == null || this.booking.ride_type == undefined) {
            this.booking.ride_type = this.rideTypes[0].id;
        }

        if (this.booking.fixed_cost != true) {
            this.booking.fixed_cost = false;
            this.booking.final_cost = null;
        }

        this.getCostEstimate();

    }

    copy(b) {

        var out = BookingForm.jsonToBookingFormBookingUser({
            booking: b
        });

        this.booking = out.booking;
        this.booking.state = null;
        this.booking.additional_charge = 0;

        console.log("Booking to copy");
        console.log(b);
        console.log(b.pickup_time);
        console.log(b.pickup_date);

        if (this.booking.fixed_cost != true) {
            this.booking.fixed_cost = false;
            this.booking.final_cost = null;
        }

        this.getCustomer(b.customer_number);
    }


    locationCMRToLocationBookingForm(l) {
        return {
            id: l.id,
            description: l.description,
            latLng: {
                latitude: l.lat,
                longitude: l.lon
            },
            active: true,
        };
    }

    validateBusinessCustomerDetails () {
        if (!this.booking.business_customer_name) {
            this.errors.business_customer_name = "Name is required"
        }
        if (!this.booking.business_customer_email) {
            this.errors.business_customer_email = "Email is required"
        }
        if (!this.booking.business_customer_reference) {
            this.errors.business_customer_reference = "Ref is required"
        }
        if (!this.booking.business_customer_authorized_by) {
            this.errors.authorized_by = "Authorized by is required"
        }
    }

    validateRide() {

        console.log("Validate ride called");

        this.errors = this.emptyErrors();

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking, true, true);
        } catch (e) {
            console.log(e);
            this.loading = false;
            return false;
        }

        for (var property in this.errors) {
            if (this.errors.hasOwnProperty(property)) {
                if (this.errors[property] != null) {
                    console.log("Validate Ride Errors:");
                    console.log(this.errors);
                    return false;
                }
            }
        }


        return true;
    }

    async bookRide(done, bookReturn, unconfirmed = false) {

        this.loading = true;

        console.log("Book ride called " + bookReturn);

        try {

            if (this.booking.pickup_location.invalid == true) {
                await this.sendLocationToServer(this.booking.pickup_location)
            }

            for (let i = 0; i < this.booking.destinations.length; i++) {
                if (this.booking.destinations[i].invalid == true) {
                    await this.sendLocationToServer(this.booking.destinations[i]);
                }
            }

        } catch (e) {
            console.log(e);
            alert("Error sending locations to server");
        }


        var url = `${this.store.state.apiUrl}/booking/makeBooking`;


        var user = null;

        this.errors = this.emptyErrors();

        var error = false;

        if (this.user.name == null || this.user.name.length == 0) {
            this.errors.name = "Enter name for customer";

            error = true;
        }

        if (this.user.contact_number == null || this.user.contact_number.length == 0) {
            this.errors.contact_number = "Enter contact number for customer";

            error = true;
        }

        if (error == true) {
            this.loading = false;
            return;
        }

        user = {
            name: this.user.name,
            contact_number: this.user.contact_number,
            vip_customer: this.user.vip_customer,
            notes: this.user.notes,
            driver_notes: this.user.driver_notes,
        };

        var booking = null;
        try {

            if (bookReturn) {
                if (this.booking.label == null) {
                    this.booking.label = "outbound_booking"
                } else {
                    this.booking.label = "return_booking"
                }
            }

            booking = this.makeBookingJSON(this.booking);

         
        } catch (e) {
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        var data = {
            user: user,
            booking: booking
        }

        if (unconfirmed) {
            data['unconfirmed'] = true
            this.booking.preassigned_driver = null
        }
        if (this.booking.outbound_booking_id != null) {
            data["outbound_booking_id"] = this.booking.outbound_booking_id;
        }

        axios({
            url: url,
            method: 'POST',
            data: encodeURIComponent(JSON.stringify(data)),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    vm.booking["outbound_booking_id"] = res.data.booking_id;
                    console.log(vm.booking["outbound_booking_id"]);
                    done(bookReturn);
                } else {
                    var errorsFromServer = res.data.errors;

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");
                        alert(errors.error);
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    backdateRide(done) {

        this.loading = true;

        console.log("Backdate ride called");

        var url = `${this.store.state.apiUrl}/booking/backdateBooking`;

        var user = null;

        this.errors = this.emptyErrors();

        var error = false;

        if (this.user.name == null || this.user.name.length == 0) {
            this.errors.name = "Enter name for customer";

            error = true;
        }

        if (this.user.contact_number == null || this.user.contact_number.length == 0) {
            this.errors.contact_number = "Enter contact number for customer";

            error = true;
        }

        if (error == true) {
            this.loading = false;
            return;
        }

        user = {
            name: this.user.name,
            contact_number: this.user.contact_number,
            notes: this.user.notes,
            driver_notes: this.user.driver_notes,
        };

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                user: user,
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");
                        alert(errors.error);
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    async updateRide(done) {
        console.log("Update ride called");

        this.loading = true;

        try {

            if (this.booking.pickup_location.invalid == true) {
                await this.sendLocationToServer(this.booking.pickup_location)
            }

            for (let i = 0; i < this.booking.destinations.length; i++) {
                if (this.booking.destinations[i].invalid == true) {
                    await this.sendLocationToServer(this.booking.destinations[i]);
                }
            }

        } catch (e) {
            console.log(e);
            alert("Error sending locations to server");
        }

        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/update`;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        console.log("Updating ride on server");

        axios({
            url: url,
            method: 'POST',
            data: encodeURIComponent(JSON.stringify({
                booking: booking,
                user: {
                    name: this.user.name,
                    contact_number: this.user.contact_number,
                },
            })),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }
    async confirmRide(done) {

        this.loading = true;

        try {

            if (this.booking.pickup_location.invalid == true) {
                await this.sendLocationToServer(this.booking.pickup_location)
            }

            for (let i = 0; i < this.booking.destinations.length; i++) {
                if (this.booking.destinations[i].invalid == true) {
                    await this.sendLocationToServer(this.booking.destinations[i]);
                }
            }

        } catch (e) {
            console.log(e);
            alert("Error sending locations to server");
        }

        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/confirm`;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        console.log("Updating ride on server");

        axios({
            url: url,
            method: 'POST',
            data: encodeURIComponent(JSON.stringify({
                booking: booking,
                user: {
                    name: this.user.name,
                    contact_number: this.user.contact_number,
                },
            })),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    updateFinalCosts() {

        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/updateCosts?finalCost=${parseInt(this.booking.final_fare * 100)}`;

        if (this.booking.fixed_cost_driver == true) {
            url += `&finalCostDriver=${parseInt(this.booking.final_cost_driver * 100)}`;
        }

        var errors = this.errors;

        console.log("Updating final costs");

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    alert("Final Costs Updated");
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    updateNotes() {
        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/updateNotes?message=${this.booking.message}&notes=${this.booking.notes}`;

        console.log("Updating notes");

        var errors = this.errors;

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    alert("Messages Updated");
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                alert("Server Error");
                console.error(err);
            });
    }
    cancelRide(done, params) {
        console.log("Cancel called");

        var url = `${this.store.state.apiUrl}/booking/cancel/${this.booking.id}?cancelOtherTripInPair=${params.cancelOtherTrip}`;

        console.log(params);

        if (params.cancellationFee == 1) {
            url += `&chargeCancellationFee=true`

            if (params.amount != null && params.amount > 0) {
                url += `&cancellationFee=${(params.amount * 100).toFixed(0)}`;
            }
        } else if (params.cancellationFee === 2) {
            url += `&chargeCancellationFee=false`
        }

        if (params.cancellationReason != "") {
            url += `&cancellationReason=${params.cancellationReason}`
        }
        if (params.otherCancellationReason != "") {
            url += `&cancellationReasonDescription=${params.otherCancellationReason}`
        }


        console.log(url);

        axios({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {
                if (res.data.error == "no_error") {
                    done();
                    // alert("Booking Cancelled");
                    console.log("Cancelled trip");
                } else {
                    // todo better errors
                    alert(res.data.error);

                    if (res.data.message != null) {
                        alert(res.data.message);
                    }

                    console.log("Failed to cancel booking");
                }
            })
            .catch(function (err) {
                console.error(err);
            });
    }
    makeBookingJSON(booking, requireDestinations, requireFinalCost) {

        var makeBookingJSON = {};

        if (!booking.asap) {
            makeBookingJSON.pickup_time = moment(booking.pickup_datetime).format("YYYY-MM-DD HH:mm");
        }

        makeBookingJSON.label = booking.label;

        makeBookingJSON.business_customer_name = booking.business_customer_name;
        makeBookingJSON.business_customer_number = booking.business_customer_number;
        makeBookingJSON.business_customer_email = booking.business_customer_email;
        makeBookingJSON.business_customer_reference = booking.business_customer_reference;

        if (booking.fixed_commission != null) {
            makeBookingJSON.fixed_commission = (booking.fixed_commission * 100).toFixed(0);
        } else {
            makeBookingJSON.fixed_commission = null;
        }

        makeBookingJSON.priority = booking.priority;

        if (booking.taxi_type != null) {
            makeBookingJSON.taxi_type = booking.taxi_type;
        }

        if (booking.pickup_location.id == null) {
            this.errors.pickup_location = "Select pickup location";
        } else {
            makeBookingJSON.pickup_location = booking.pickup_location.id;
        }

        if (booking.pickup_info != null && booking.pickup_info.active == true) {
            makeBookingJSON.pickup_info = booking.pickup_info;
        }

        if (booking.destination_info != null && booking.destination_info.active == true) {
            makeBookingJSON.destination_info = booking.destination_info;
        }

        makeBookingJSON.destinations = [];

        for (var i = 0; i < booking.destinations.length; i++) {
            if (booking.destinations[i].id != null) {
                makeBookingJSON.destinations.push(booking.destinations[i].id);
            }
        }

        if (booking.destinations[0].id == null && requireDestinations == true) {
            this.errors['destination_0'] = "Repeat booking requires destination locations";
        }

        makeBookingJSON.via_info = [];

        for (var j = 0; j < booking.via_info.length; j++) {
            if (booking.via_info[j] != null && booking.via_info[j].active == true) {
                makeBookingJSON.via_info.push(booking.via_info[j]);
            } else if (booking.via_info[j].active == false) {
                makeBookingJSON.via_info.push(BookingForm.emptyViaInfo());
            }
        }

        if (booking.promocode != null) {
            makeBookingJSON.promocode = booking.promocode;
        }

        makeBookingJSON.ride_type = booking.ride_type;

        makeBookingJSON.num_people = booking.num_people;

        if (booking.luggage != null) {
            makeBookingJSON.luggage = booking.luggage;
        } else {
            makeBookingJSON.luggage = 0;
        }

        makeBookingJSON.require_ppe = booking.require_ppe;

        makeBookingJSON.needs_disabled_access = booking.needs_disabled_access;
        makeBookingJSON.premium = booking.premium;

        if (booking.flight_number != null) {
            makeBookingJSON.flight_number = booking.flight_number;
        }

        if (booking.room_number != null) {
            makeBookingJSON.room_number = booking.room_number;
        }

        makeBookingJSON.meet_and_greet = booking.meet_and_greet;
        makeBookingJSON.needs_pets = booking.needs_pets;
        makeBookingJSON.payment_type = booking.payment_type;


        makeBookingJSON.authorized_by = booking.authorized_by;

        if(booking.availability_status) {
            makeBookingJSON.availability_status = booking.availability_status
        }

        if (booking.payment_type == "card") {
            makeBookingJSON.card = booking.card;

            if (booking.card == null) {
                this.errors.card = "Select card";
            }
        }

        if (booking.additional_charge != null) {
            makeBookingJSON.additional_charge = booking.additional_charge * 100;
        } else {
            makeBookingJSON.additional_charge = 0;
        }

        if (booking.fixedCostType == this.FIXED_COST_DISPATCHER() && booking.fixed_cost == true && booking.finalFareMode == false) {
            makeBookingJSON.fixed_cost = booking.fixed_cost;
            makeBookingJSON.final_cost = booking.final_fare * 100;
        } else if (booking.fixedCostType == this.FIXED_COST_DISPATCHER() && booking.fixed_cost == true && booking.finalFareMode == true) {
            makeBookingJSON.fixed_cost = booking.fixed_cost;

            if (makeBookingJSON.fixed_cost) {
            makeBookingJSON.final_fare = booking.final_fare * 100;
            }
        }

        // if (booking.final_cost == 0 && requireFinalCost == true) {
        //     this.errors.final_cost = "Repeat booking requires a fixed final cost";
        // }

        if (booking.fixedCostDriverType == this.FIXED_COST_DISPATCHER() && booking.fixed_cost_driver == true) {
            makeBookingJSON.fixed_cost_driver = booking.fixed_cost_driver;
            makeBookingJSON.final_cost_driver = booking.final_cost_driver * 100;
        }

        makeBookingJSON.manual_dispatch = booking.manual_dispatch;
        makeBookingJSON.offer_booking_publically = booking.offer_booking_publically;

        if (booking.preassigned_driver != null) {
            makeBookingJSON.preassigned_driver = booking.preassigned_driver;
        }

        makeBookingJSON.notes = booking.notes;

        makeBookingJSON.message = booking.message;

        if (booking.predefinedMessage != null) {
            makeBookingJSON.message = booking.predefinedMessage + "\n" + booking.message;
        }

        if (booking.bookingAdditionalCharges != null) {
            var locationAdditionalChargesToIgnore = [];
            var propertyAdditionalChargesToIgnore = [];

            var locationAdditionalChargesToForce = [];
            var propertyAdditionalChargesToForce = [];
            var waitingTimeCharges = [];

            for (var i = 0; i < booking.bookingAdditionalCharges.length; i++) {
                var bac =  booking.bookingAdditionalCharges[i];

                if (!bac.enabled) {
                    if (bac.locationAdditionalCharge != null) {
                        locationAdditionalChargesToIgnore.push(bac.locationAdditionalCharge.id);
                    } else {
                        propertyAdditionalChargesToIgnore.push(bac.propertyAdditionalCharge.id);
                    }
                }

                if (bac.force == true) {
                    if (bac.locationAdditionalCharge != null) {
                        locationAdditionalChargesToForce.push(bac.locationAdditionalCharge.id);
                    } else {
                        propertyAdditionalChargesToForce.push(bac.propertyAdditionalCharge.id);
                    }
                }

/*
                if (!bac.enabled) {
                    if (bac.locationAdditionalCharge != null) {
                        locationAdditionalChargesToIgnore.push(bac.locationAdditionalCharge.id);
                    } else if(bac.propertyAdditionalCharge != null) {
                        propertyAdditionalChargesToIgnore.push(bac.propertyAdditionalCharge.id);
                    } else if (bac.waiting_time != null) {
                        waitingTimeCharges.push(bac.waiting_time.id)
                    }
                }

                if (bac.force == true) {
                    if (bac.locationAdditionalCharge != null) {
                        locationAdditionalChargesToForce.push(bac.locationAdditionalCharge.id);
                    } else if(bac.propertyAdditionalCharge != null && !bac.propertyAdditionalCharge.enabled) {
                        locationAdditionalChargesToForce.push(bac.propertyAdditionalCharge.id);
                    } else if (bac.waiting_time != null) {
                        waitingTimeCharges.push(bac.waiting_time.id)
                    }
                }
*/
            }

            makeBookingJSON.location_additional_charges_to_ignore = locationAdditionalChargesToIgnore;
            makeBookingJSON.property_additional_charges_to_ignore = propertyAdditionalChargesToIgnore;

            makeBookingJSON.location_additional_charges_to_force = locationAdditionalChargesToForce;
            makeBookingJSON.property_additional_charges_to_force = propertyAdditionalChargesToForce;
        }

        // console.log(makeBookingJSON);

        return makeBookingJSON;
    }


    static jsonToBookingFormBookingUser(jsonBookingUser) {


        var booking = BookingForm.emptyBooking();

        var jsonBooking = jsonBookingUser.booking;
        var jsonUser = jsonBookingUser.booking.user;
        var jsonReviews = jsonBookingUser.reviews;

        if (jsonBookingUser.waiting_time) {
            booking.waiting_time_charges = jsonBookingUser.waiting_time
        }
        if (jsonBookingUser.waiting_time_will_kick_in && booking.waiting_time_charges) {
            booking.waiting_time_charges.waiting_time_will_kick_in = jsonBookingUser.waiting_time_will_kick_in
        }
        if (!jsonBooking.asap) {
            booking.asap = false;

            var date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;

            booking.pickup_date = date.format("YYYY-MM-DD");
            booking.pickup_time = date.format("HH:mm");

        } else {
            booking.asap = true;

            var date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;

            booking.pickup_date = date.format("YYYY-MM-DD");
            booking.pickup_time = date.format("HH:mm");
        }

        booking.id = jsonBooking.id;
        booking.token = jsonBooking.token;

        booking.business_customer_name = jsonBooking.business_customer_name;
        booking.business_customer_number = jsonBooking.business_customer_number;
        booking.business_customer_email = jsonBooking.business_customer_email;
        booking.business_customer_reference = jsonBooking.business_customer_reference;
        booking.priority = jsonBooking.priority;

        booking.waiting_time = jsonBooking.waiting_time;

        booking.booking_cancellation_fee = jsonBooking.booking_cancellation_fee;

        if (jsonBooking.fixed_commission != null ) {
            booking.fixed_commission = (jsonBooking.fixed_commission / 100).toFixed(2);
        }

        booking.pickup_location = jsonBooking.pickup_location;
        booking.pickup_location.latLng = {
            latitude: booking.pickup_location.lat,
            longitude: booking.pickup_location.lon,
        };

        booking.pickup_location.invalid = false;

        if (jsonBooking.pickup_info != null) {
            booking.pickup_info = jsonBooking.pickup_info;
            booking.pickup_info.active = true;
        }

        if (jsonBooking.driver_percentage) {
            booking.driver_percentage = jsonBooking.driver_percentage
        } else {
            booking.driver_percentage = null
        }

        if (jsonBooking.destination_info != null) {
            booking.destination_info = jsonBooking.destination_info;
            booking.destination_info.active = true;
        }

        if (jsonBooking.destinations != null && jsonBooking.destinations.length > 0) {

            booking.destinations = [];

            for (var i = 0; i < jsonBooking.destinations.length; i++) {
                booking.destinations.push(jsonBooking.destinations[i]);

                booking.destinations[i].latLng = {
                    latitude: booking.destinations[i].lat,
                    longitude: booking.destinations[i].lon,
                };

                booking.destinations[i].invalid = false;

                if (i > 0) {
                    try {
                        if (jsonBooking.via_info != null) {
                            if (jsonBooking.via_info[i - 1] != null) {
                                booking.via_info.push(jsonBooking.via_info[i - 1]);
                                booking.via_info[i - 1].active = true;

                            } else {
                                booking.via_info.push(this.emptyViaInfo());
                            }
                        } else {
                            booking.via_info.push(this.emptyViaInfo());
                        }
                    } catch (e) {
                        booking.via_info.push(this.emptyViaInfo());
                        console.log(e);
                    }
                }
            }
        }

        if (jsonBooking.promocode != null) {
            booking.promocode = jsonBooking.promocode.id;
        }

        if (jsonBooking.ride_type != null) {
            booking.ride_type = jsonBooking.ride_type;
        }

        booking.require_ppe = jsonBooking.require_ppe;

        booking.num_people = jsonBooking.num_people;
        booking.luggage = jsonBooking.luggage;
        booking.needs_disabled_access = jsonBooking.needs_disabled_access;
        booking.premium = jsonBooking.premium;

        booking.booking_type = jsonBooking.booking_type;

        if (jsonBooking.flight_number != null) {
            booking.flight_number = jsonBooking.flight_number;
        }

        if (jsonBooking.room_number != null) {
            booking.room_number = jsonBooking.room_number;
        }

        booking.meet_and_greet = jsonBooking.meet_and_greet;
        booking.needs_pets = jsonBooking.needs_pets;

        booking.payment_type = jsonBooking.payment_type;
        booking.card_payment_type = jsonBooking.card_payment_type;

        booking.cart = jsonBookingUser.cart;

        if (jsonBooking.payment_type == "card") {
            booking.card = jsonBooking.card;
        }

        booking.taxi_type = jsonBooking.taxi_type;

        if (booking.taxi_type != null) {
            booking.taxi_type = booking.taxi_type.replace(/^\w/, c => c.toUpperCase());
        }

        booking.additional_charge = jsonBooking.additional_charge / 100.0;

        booking.state = jsonBooking.state;

        booking.fixed_cost = jsonBooking.fixed_cost;

        booking.final_cost = jsonBooking.final_cost / 100.0;

        if (booking.final_cost != 0 || (booking.fixed_cost == true || booking.state == 'completed')) {
            if (jsonBooking.final_fare == null || jsonBooking.final_fare == 0) {
                if (booking.fixed_cost || booking.state == 'completed') {
                    booking.final_fare = jsonBooking.final_cost / 100.0;
                    booking.finalFareMode = false;
                }
            } else { 
                if (booking.fixed_cost  || booking.state == 'completed') {
                    booking.final_fare = jsonBooking.final_fare / 100.0;
                    booking.finalFareMode = true;
                }
            }
        }

        if (jsonBooking.booking_cost_breakdown != null) {
            booking.bookingAdditionalCharges.length = 0;
            booking.bookingAdditionalCharges.push(...jsonBooking.booking_cost_breakdown.bookingAdditionalCharges);
        }

        booking.bookingCostBreakdown = jsonBooking.booking_cost_breakdown;

        if (jsonBooking.additionalChargeRequests != null) {
            booking.additionalChargeRequests.push(...jsonBooking.additionalChargeRequests)
        }

        if (jsonBooking.final_cost_promotion != null) {
            booking.final_cost_promotion = jsonBooking.final_cost_promotion / 100.0;
        }

        if (jsonBooking.fixed_cost_type != null) {
            booking.fixedCostType = jsonBooking.fixed_cost_type;
        }

        booking.final_cost_driver = jsonBooking.fixed_cost_driver / 100.0;

        if (jsonBooking.fixed_cost_driver_type != null) {
            booking.fixedCostDriverType = jsonBooking.fixed_cost_driver_type;
            booking.fixed_cost_driver = true;
        }

        if (jsonBooking.notes != null) {
            booking.notes = jsonBooking.notes;
        }

        if (jsonBooking.message != null) {
            booking.message = jsonBooking.message;
        }

        booking.created_at = jsonBooking.created_at;
        booking.accept_time = jsonBooking.accept_time;
        booking.arrived_time = jsonBooking.arrived_time;
        booking.pob_time = jsonBooking.pob_time;
        booking.finished_time = jsonBooking.finished_time;
        booking.estimated_dispatch_time = jsonBooking.estimated_dispatch_time;

        booking.card_status = jsonBooking.card_status;
        booking.card_status_reason = jsonBooking.card_status_reason;

        booking.cancellation_type = jsonBooking.cancellation_type;
        booking.cancellation_reason = jsonBooking.cancellation_reason;
        booking.cancellation_description = jsonBooking.cancellation_description;

        booking.route = jsonBooking.route == null ? {} : jsonBooking.route;
        booking.route.time = jsonBooking.estimated_time == null ? 0 : jsonBooking.estimated_time;

        booking.manual_dispatch = jsonBooking.manual_dispatch;
        booking.offer_booking_publically = jsonBooking.offer_booking_publically;

        booking.sumup_transaction = jsonBooking.sumup_transaction;
        booking.refunded = jsonBooking.refunded;

        booking.track_booking_url = jsonBooking.track_booking_url;

        booking.authorized_by = jsonBooking.authorized_by;
        booking.booked_by = jsonBooking.booked_by;

        booking.pickup_location_trace = jsonBooking.pickup_location_trace
        booking.destination_location_traces = jsonBooking.destination_location_traces

        if (jsonBooking.preassigned_driver != null) {
            console.log("Preassigned driver not null - " + jsonBooking.preassigned_driver.driver.id);
            booking.preassigned_driver = jsonBooking.preassigned_driver.driver.id;
            booking.preassigned_driver_email = jsonBooking.preassigned_driver.driver.email;
            booking.eligibleDriversForPreassign = [{
                id: jsonBooking.preassigned_driver.driver.id,
                callsign: jsonBooking.preassigned_driver.driver.callsign,
                name: jsonBooking.preassigned_driver.driver.name
            },];
        } else {
            console.log("Preassigned driver null");
            booking.eligibleDriversForPreassign = [];
            booking.preassigned_driver = null;
        }

        booking.driver_trace = jsonBooking.driver_trace;

        booking.dispatched_by = jsonBooking.dispatched_by;

        booking.driver = jsonBooking.driver;

        if (booking.fixed_cost == false && booking.state != 'completed') {
            console.log("Setting final cost to null");
            booking.final_cost = null;
        }

        if (jsonBooking.fixed_cost_driver_type == undefined) {
            console.log("Setting final cost driver to null");
            booking.final_cost_driver = null;
        }


        var user = BookingForm.emptyUser();

        try {
            if (jsonUser) {
                user.id = jsonUser.id;
                user.name = jsonUser.name;
                user.contact_number = jsonUser.contact_number;
                user.email = jsonUser.email;
                user.cards = jsonUser.cards;
                user.promocodes = jsonUser.promocodes;
                user.business = jsonUser.business;
                user.business_pickup_address =
                    jsonUser.business_pickup_address;
                user.notes = jsonUser.notes;
                user.recent_bookings = jsonUser.recent_bookings;
                user.active_bookings = jsonUser.active_bookings;
                user.locked_out = jsonUser.locked_out;
                user.vip_customer = jsonUser.vip;
                user.id = jsonUser.id;
            }
        } catch (e) {
            console.log(e);
        }

        return {
            booking: booking,
            user: user,
            reviews: jsonReviews,
        };
    }
    static jsonToBookingFormBookingUserForReturnBooking(jsonBookingUser) {

        var booking = BookingForm.emptyBooking();

        var jsonBooking = jsonBookingUser.booking;
        var jsonUser = jsonBookingUser.booking.user;
        var jsonReviews = jsonBookingUser.reviews;

        if (!jsonBooking.asap) {
            booking.asap = false;

            var date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;
            booking.pickup_date = date.format("YYYY-MM-DD");
            if (date.isAfter()) {
                booking.pickup_time = date.format("HH:mm");
            } else {
                booking.pickup_time = moment().format("HH:mm");
            }

        } else {
            booking.asap = true;

            date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;

            booking.pickup_date = date.format("YYYY-MM-DD");
            booking.pickup_time = date.format("HH:mm");
        }

        booking.id = jsonBooking.id;
        booking.token = jsonBooking.token;

        booking.business_customer_name = jsonBooking.business_customer_name;
        booking.business_customer_number = jsonBooking.business_customer_number;
        booking.business_customer_email = jsonBooking.business_customer_email;
        booking.business_customer_reference = jsonBooking.business_customer_reference;
        booking.priority = jsonBooking.priority;

        if (jsonBooking.fixed_commission != null ) {
            booking.fixed_commission = (jsonBooking.fixed_commission / 100).toFixed(2);
        }

        let pickup = jsonBooking.destinations[0]
        let destination = jsonBooking.pickup_location;
        booking.pickup_location = pickup;
        booking.pickup_location.latLng = {
            latitude: pickup.lat,
            longitude: pickup.lon,
        };

        booking.pickup_location.invalid = false;

        if (jsonBooking.pickup_info != null) {
            booking.pickup_info = jsonBooking.destination_info;
            booking.pickup_info.active = true;
        }

        if (jsonBooking.destination_info != null) {
            booking.destination_info = jsonBooking.pickup_info;
            booking.destination_info.active = true;
        }

        if (jsonBooking.destinations != null && jsonBooking.destinations.length > 0) {

            // jsonBooking.destinations[0] = destination
            let newDestinationsArray = []
            newDestinationsArray.push(destination)
            let vias = jsonBooking.destinations.slice(1).reverse()
            newDestinationsArray.push(...vias)
            jsonBooking.destinations = newDestinationsArray
            booking.destinations = [];

            for (var i = 0; i < jsonBooking.destinations.length; i++) {
                booking.destinations.push(jsonBooking.destinations[i]);

                booking.destinations[i].latLng = {
                    latitude: booking.destinations[i].lat,
                    longitude: booking.destinations[i].lon,
                };

                booking.destinations[i].invalid = false;

                if (i > 0) {
                    try {
                        if (jsonBooking.via_info != null) {
                            if (jsonBooking.via_info[i - 1] != null) {
                                booking.via_info.push(jsonBooking.via_info[i - 1]);
                                booking.via_info[i - 1].active = true;

                            } else {
                                booking.via_info.push(this.emptyViaInfo());
                            }
                        } else {
                            booking.via_info.push(this.emptyViaInfo());
                        }
                    } catch (e) {
                        booking.via_info.push(this.emptyViaInfo());
                        console.log(e);
                    }
                }
            }
        }

        if (jsonBooking.promocode != null) {
            booking.promocode = jsonBooking.promocode.id;
        }

        if (jsonBooking.ride_type != null) {
            booking.ride_type = jsonBooking.ride_type;
        }

        booking.require_ppe = jsonBooking.require_ppe;

        booking.num_people = jsonBooking.num_people;
        booking.luggage = jsonBooking.luggage;
        booking.needs_disabled_access = jsonBooking.needs_disabled_access;
        booking.premium = jsonBooking.premium;

        booking.booking_type = jsonBooking.booking_type;

        if (jsonBooking.flight_number != null) {
            booking.flight_number = jsonBooking.flight_number;
        }

        if (jsonBooking.room_number != null) {
            booking.room_number = jsonBooking.room_number;
        }

        booking.meet_and_greet = jsonBooking.meet_and_greet;
        booking.needs_pets = jsonBooking.needs_pets;

        booking.payment_type = jsonBooking.payment_type;
        booking.card_payment_type = jsonBooking.card_payment_type;

        booking.cart = jsonBookingUser.cart;

        if (jsonBooking.payment_type == "card") {
            booking.card = jsonBooking.card;
        }

        booking.taxi_type = jsonBooking.taxi_type;

        if (booking.taxi_type != null) {
            booking.taxi_type = booking.taxi_type.replace(/^\w/, c => c.toUpperCase());
        }

        booking.additional_charge = jsonBooking.additional_charge / 100.0;

        booking.state = jsonBooking.state;

        booking.fixed_cost = jsonBooking.fixed_cost;

        booking.final_cost = jsonBooking.final_cost / 100.0;

        if (booking.final_cost != 0 || (booking.fixed_cost == true || booking.state == 'completed')) {
            if (jsonBooking.final_fare == null || jsonBooking.final_fare == 0) {
                if (booking.fixed_cost || booking.state == 'completed') {
                    booking.final_fare = jsonBooking.final_cost / 100.0;
                    booking.finalFareMode = false;
                }
            } else {
                if (booking.fixed_cost  || booking.state == 'completed') {
                    booking.final_fare = jsonBooking.final_fare / 100.0;
                    booking.finalFareMode = true;
                }
            }
        }

        if (jsonBooking.booking_cost_breakdown != null) {
            booking.bookingAdditionalCharges.length = 0;
            booking.bookingAdditionalCharges.push(...jsonBooking.booking_cost_breakdown.bookingAdditionalCharges);
        }

        booking.bookingCostBreakdown = jsonBooking.booking_cost_breakdown;

        if (jsonBooking.additionalChargeRequests != null) {
            booking.additionalChargeRequests.push(...jsonBooking.additionalChargeRequests)
        }

        if (jsonBooking.final_cost_promotion != null) {
            booking.final_cost_promotion = jsonBooking.final_cost_promotion / 100.0;
        }

        if (jsonBooking.fixed_cost_type != null) {
            booking.fixedCostType = jsonBooking.fixed_cost_type;
        }

        booking.final_cost_driver = jsonBooking.fixed_cost_driver / 100.0;

        if (jsonBooking.fixed_cost_driver_type != null) {
            booking.fixedCostDriverType = jsonBooking.fixed_cost_driver_type;
            booking.fixed_cost_driver = true;
        }

        if (jsonBooking.notes != null) {
            booking.notes = jsonBooking.notes;
        }

        if (jsonBooking.message != null) {
            booking.message = jsonBooking.message;
        }

        booking.created_at = jsonBooking.created_at;
        booking.accept_time = jsonBooking.accept_time;
        booking.arrived_time = jsonBooking.arrived_time;
        booking.pob_time = jsonBooking.pob_time;
        booking.finished_time = jsonBooking.finished_time;
        booking.estimated_dispatch_time = jsonBooking.estimated_dispatch_time;

        booking.card_status = jsonBooking.card_status;
        booking.card_status_reason = jsonBooking.card_status_reason;

        booking.cancellation_type = jsonBooking.cancellation_type;
        booking.cancellation_reason = jsonBooking.cancellation_reason;
        booking.cancellation_description = jsonBooking.cancellation_description;

        booking.route = jsonBooking.route == null ? {} : jsonBooking.route;
        booking.route.time = jsonBooking.estimated_time == null ? 0 : jsonBooking.estimated_time;

        booking.manual_dispatch = jsonBooking.manual_dispatch;
        booking.offer_booking_publically = jsonBooking.offer_booking_publically;

        booking.sumup_transaction = jsonBooking.sumup_transaction;
        booking.refunded = jsonBooking.refunded;

        booking.track_booking_url = jsonBooking.track_booking_url;

        booking.authorized_by = jsonBooking.authorized_by;
        booking.booked_by = jsonBooking.booked_by;

        if (jsonBooking.preassigned_driver != null) {
            console.log("Preassigned driver not null - " + jsonBooking.preassigned_driver.driver.id);
            booking.preassigned_driver = jsonBooking.preassigned_driver.driver.id;
            booking.preassigned_driver_email = jsonBooking.preassigned_driver.driver.email;

            booking.eligibleDriversForPreassign = [{
                id: jsonBooking.preassigned_driver.driver.id,
                callsign: jsonBooking.preassigned_driver.driver.callsign,
                name: jsonBooking.preassigned_driver.driver.name
            },];
        } else {
            console.log("Preassigned driver null");
            booking.eligibleDriversForPreassign = [];
            booking.preassigned_driver = null;
        }

        booking.driver_trace = jsonBooking.driver_trace;

        booking.dispatched_by = jsonBooking.dispatched_by;
        booking.booking_type = jsonBooking.booking_type;

        booking.driver = jsonBooking.driver;

        if (booking.fixed_cost == false && booking.state != 'completed') {
            console.log("Setting final cost to null");
            booking.final_cost = null;
        }

        if (jsonBooking.fixed_cost_driver_type == undefined) {
            console.log("Setting final cost driver to null");
            booking.final_cost_driver = null;
        }


        var user = BookingForm.emptyUser();

        try {
            user.id = jsonUser.id;
            user.name = jsonUser.name;
            user.contact_number = jsonUser.contact_number;
            user.email = jsonUser.email;
            user.cards = jsonUser.cards;
            user.promocodes = jsonUser.promocodes;
            user.business = jsonUser.business;
            user.business_pickup_address =
                jsonUser.business_pickup_address;
            user.notes = jsonUser.notes;
            user.recent_bookings = jsonUser.recent_bookings;
            user.active_bookings = jsonUser.active_bookings;
            user.locked_out = jsonUser.locked_out;
        } catch (e) {
            console.log(e);
        }

        return {
            booking: booking,
            user: user,
            reviews: jsonReviews,
        };
    }
}